export const sendMessageToExtension = (message, responseCallback = () => {}) => {
  const allExtensionsIds = [
    'hhnemhalmbhdldblamkefkjnalpmadhm', // Live
    'bbkklnglldbkcleibooadedgoodihbon', // Beta
    'bdbjjmfmfmelcofcnnodmbgknnkgjlfb', // Local
  ];

  allExtensionsIds.forEach((extensionId) => {
    window.chrome?.runtime?.sendMessage(
      extensionId,
      message,
      responseCallback,
    );
  });
};

export const closeExtensionWindow = () => {
  sendMessageToExtension('CLOSE_EXTENSION_WINDOW');
};
